import { money, xx, pc, GATE } from "../../lib/casePath";
import { Card, Pill } from "../kit/Kit";

const REC = { Aprobar: "bg-emerald-600", "Aprobar con condiciones": "bg-[#111]", "Aprobar por monto menor": "bg-amber-600", Rechazar: "bg-rose-600" };

const Ring = ({ v }) => {
  const r = 52;
  const C = 2 * Math.PI * r;
  return (
    <svg width="140" height="140" viewBox="0 0 140 140" data-testid="analisis-score-ring">
      <circle cx="70" cy="70" r={r} stroke="#F2F0EC" strokeWidth="12" fill="none" />
      <circle cx="70" cy="70" r={r} stroke="#E8643C" strokeWidth="12" fill="none" strokeLinecap="round" strokeDasharray={C} strokeDashoffset={C * (1 - v / 100)} transform="rotate(-90 70 70)" style={{ transition: "stroke-dashoffset .6s ease" }} />
      <text x="70" y="68" textAnchor="middle" className="font-serif-display" fontSize="34" fontWeight="800" fill="#111">{v}</text>
      <text x="70" y="90" textAnchor="middle" fontSize="11" fill="#8C867A">de 100</text>
    </svg>
  );
};

export const StepAnalisis = ({ result: r }) => {
  if (!r) return null;
  const y = r.proj.years;
  return (
    <>
      <div className="grid gap-6 lg:grid-cols-12">
        <Card className="lg:col-span-5" testid="analisis-decision">
          <div className="flex items-center gap-6">
            <Ring v={r.score.total} />
            <div>
              <p className="text-xs font-semibold uppercase tracking-widest text-[#8C867A]">Banda</p>
              <p className="font-serif-display text-4xl font-bold" data-testid="analisis-band">{r.score.band} <span className="text-lg font-normal text-[#5C5850]">{r.bandName[r.score.band]}</span></p>
              <p className="mt-1 text-sm text-[#5C5850]">Riesgo {r.riskLevel[r.score.band].toLowerCase()}</p>
            </div>
          </div>
          <div className={`mt-6 rounded-xl px-5 py-4 text-white ${REC[r.rec]}`} data-testid="analisis-rec"><p className="text-xs uppercase tracking-widest opacity-80">Dictamen del motor</p><p className="font-serif-display text-2xl font-bold">{r.rec}</p></div>
          <p className="mt-4 text-sm" data-testid="analisis-route"><span className="font-semibold">Resuelve:</span> {r.route}{r.routeWhy.length ? ` (${r.routeWhy.join("; ")})` : ""}</p>
        </Card>
        <div className="grid grid-cols-2 gap-4 lg:col-span-7" data-testid="analisis-kpis">
          {[["DSCR año 1 / 2", y.map((v) => xx(v.dscr)).join(" / ")], [`DSCR estrés −${r.p.stress}%`, y.map((v) => xx(v.dscrS)).join(" / ")], ["Deuda / UAFIRDA", xx(r.lev)], ["Pasivo / Capital", xx(r.pasCap)],
            ["Razón circulante", xx(r.rc)], ["Margen operativo", pc(r.fy.margen)], ["Tasa motor / aplicada", `${r.pz.motor.toFixed(2)}% / ${r.rate.toFixed(2)}%`], ["Monto recomendado", money(r.montoRecTotal)]].map(([l, v]) => (
            <div key={l} className="rounded-2xl border border-[#E2DDD5] bg-white p-5"><p className="text-xs font-semibold uppercase tracking-widest text-[#8C867A]">{l}</p><p className="font-serif-display mt-1.5 text-xl font-bold">{v}</p></div>
          ))}
        </div>
      </div>
      <div className="grid gap-6 lg:grid-cols-2">
        <Card title="Scorecard" testid="analisis-scorecard">
          <div className="space-y-3">{r.score.F.map((f) => (
            <div key={f.key} data-testid={`score-factor-${f.key}`}>
              <div className="flex justify-between text-sm"><span className="font-semibold">{f.name}</span><span className="tabular-nums">{f.pts}/{f.max}</span></div>
              <div className="mt-1 h-2 overflow-hidden rounded-full bg-[#F2F0EC]"><div className="h-full rounded-full bg-[#E8643C]" style={{ width: `${(f.pts / f.max) * 100}%` }} /></div>
              <p className="mt-0.5 text-xs text-[#8C867A]">{f.detail}{f.hint ? ` · ${f.hint}` : ""}</p>
            </div>))}
          </div>
        </Card>
        <Card title="Cumplimiento de política" testid="analisis-gates">
          <div className="space-y-2">{r.gates.map((g) => (
            <div key={g.key} className="flex items-start gap-3 rounded-xl bg-[#FAF8F5] px-4 py-2.5" data-testid={`gate-${g.key}`}>
              <Pill cls={GATE[g.status][1]}>{GATE[g.status][0]}</Pill>
              <div className="min-w-0"><p className="text-sm font-semibold">{g.name}</p><p className="text-xs text-[#8C867A]">{g.detail}</p></div>
            </div>))}
          </div>
        </Card>
      </div>
      <Card title="Montos máximos" subtitle="El monto recomendado es el menor de estos límites." testid="analisis-caps">
        <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-5">{r.caps.map((k) => (
          <div key={k.k} className={`rounded-xl border p-4 ${k.k === r.minCap.k ? "border-[#E8643C] bg-[#FDF0EB]" : "border-[#E2DDD5]"}`}><p className="text-xs text-[#5C5850]">{k.l}</p><p className="font-serif-display mt-1 text-lg font-bold">{money(k.v)}</p></div>))}
        </div>
      </Card>
    </>
  );
};
